var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRewardSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.3125 25.0347H20.45C21.5875 25.0347 22.5325 24.0197 22.5325 22.7947C22.5325 21.2722 21.99 20.9747 21.0975 20.6597L19.33 20.0472V25.0347H19.3125Z",
    fill: "#00FD92"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9476 0.500029C8.28761 0.535029 0.465117 8.39252 0.500117 18.0525C0.535117 27.7125 8.39261 35.535 18.0526 35.5C27.7126 35.465 35.5351 27.6075 35.5001 17.9475C35.4651 8.28752 27.6076 0.482529 17.9476 0.500029ZM21.9551 18.175C23.3201 18.6475 25.1576 19.6625 25.1576 22.795C25.1576 25.49 23.0401 27.66 20.4501 27.66H19.3126V28.675C19.3126 29.3925 18.7176 29.9875 18.0001 29.9875C17.2826 29.9875 16.6876 29.3925 16.6876 28.675V27.66H16.0576C13.1876 27.66 10.8601 25.245 10.8601 22.27C10.8601 21.5525 11.4551 20.9575 12.1726 20.9575C12.8901 20.9575 13.4851 21.5525 13.4851 22.27C13.4851 23.7925 14.6401 25.035 16.0576 25.035H16.6876V19.12L14.0451 18.175C12.6801 17.7025 10.8426 16.6875 10.8426 13.555C10.8426 10.86 12.9601 8.69002 15.5501 8.69002H16.6876V7.67502C16.6876 6.95752 17.2826 6.36253 18.0001 6.36253C18.7176 6.36253 19.3126 6.95752 19.3126 7.67502V8.69002H19.9426C22.8126 8.69002 25.1401 11.105 25.1401 14.08C25.1401 14.7975 24.5451 15.3925 23.8276 15.3925C23.1101 15.3925 22.5151 14.7975 22.5151 14.08C22.5151 12.5575 21.3601 11.315 19.9426 11.315H19.3126V17.23L21.9551 18.175Z",
    fill: "#00FD92"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4851 13.5724C13.4851 15.0949 14.0276 15.3924 14.9201 15.7074L16.6876 16.3199V11.3149H15.5501C14.4126 11.3149 13.4851 12.3299 13.4851 13.5724Z",
    fill: "#00FD92"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRewardSvg);
export default __webpack_public_path__ + "static/media/rewardSvg.5d1d33a4ab84299fd6a229247b0fc470.svg";
export { ForwardRef as ReactComponent };